import React, { useEffect } from "react";
import { Table, message } from "antd";
import { ColumnsType } from "antd/es/table";
import { YhBut } from "@/components/YhButton";
import { useWebSiteModel } from "../webSiteModel";
import { webSiteService } from "../webSiteService";



export function DataTable() {
    const {
        dataSource, pgCfg,
        loadData, serDetailDrawer
    } = useWebSiteModel();

    const remove = (id: string) => {
        webSiteService.remove(id).then(res => {
            if (res) {
                message.success("删除成功");
                loadData();
            }
        })
    }
    const columns: ColumnsType<any> = [
        {
            title: '序号',
            width: 100,
            align: "center",
            render: (t, r, i) => i + 1
        },
        {
            title: '站点域名',
            align: "center",
            dataIndex: 'code',
        },
        {
            title: '站点名称',
            align: "center",
            dataIndex: 'name',
        },
        {
            title: '是否免密登录',
            align: "center",
            dataIndex: 'isPwd',
            render: text => +text ? "是" : "否"
        },
        {
            title: '用户名称',
            align: "center",
            dataIndex: 'userName',
        },
        {
            title: '用户密码',
            align: "center",
            dataIndex: 'userPwd',
        },
        {
            title: '顺位',
            align: "center",
            dataIndex: 'orderNum',
        },
        {
            title: '备注',
            align: "center",
            dataIndex: 'note',
        },
        {
            title: '操作',
            width: 200,
            align: "center",
            className: "td-wrap",
            render: (txt, record) => <>
                <YhBut
                    type="edit"
                    txt="编辑"
                    click={() => serDetailDrawer({ visible: true, mode: "edit", record })}
                />
                <YhBut
                    type="delete"
                    txt="删除"
                    click={() => remove(record.id)}
                />
            </>
        }
    ];

    useEffect(() => {
        loadData();
    }, [])

    return (
        <Table
            rowKey={record => record.id}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            scroll={{ x: 'max-content', }}
        />
    )
}
